// src/utils/auth.js

// Complete authentication data cleanup
export const clearAuthData = () => {
  // Clear all authentication tokens
  localStorage.removeItem('token');
  localStorage.removeItem('userToken');
  localStorage.removeItem('loginTime');
  localStorage.removeItem('userId');
  localStorage.removeItem('userName');
  
  // Clear user-specific cached data
  const keys = Object.keys(localStorage);
  keys.forEach(key => {
    // Remove user-specific data patterns
    if (key.startsWith('wordStats_') || 
        key.startsWith('userProgress_') || 
        key.startsWith('lessonData_') ||
        key.startsWith('userSettings_') ||
        key.startsWith('cachedProfile_') ||
        key.includes('_userId_')) {
      localStorage.removeItem(key);
    }
  });

  // Clear session storage as well
  sessionStorage.clear();
};

// Enhanced session validation
export const isSessionValid = () => {
  const userId = localStorage.getItem('userId');
  const token = localStorage.getItem('token');
  const loginTime = parseInt(localStorage.getItem('loginTime'));
  
  if (!userId || !token || !loginTime) {
    return false;
  }
  
  const now = new Date().getTime();
  const sessionDuration = 10 * 60 * 1000; // 10 minutes
  
  return (now - loginTime) <= sessionDuration;
};

// Get current authenticated user
export const getCurrentUser = () => {
  if (!isSessionValid()) {
    return null;
  }
  
  return {
    userId: localStorage.getItem('userId'),
    userName: localStorage.getItem('userName'),
    token: localStorage.getItem('token')
  };
};

// Secure logout with user confirmation
export const handleSessionExpiry = (navigate, reason = 'Session expired') => {
  clearAuthData();
  
  // Force reload to clear any cached state
  setTimeout(() => {
    window.location.href = '/login';
  }, 100);
};

// Safe login data setter
export const setAuthData = (userData) => {
  // Clear any existing data first
  clearAuthData();
  
  // Set new user data
  localStorage.setItem('token', userData.token);
  localStorage.setItem('userId', userData.user._id);
  localStorage.setItem('userName', userData.user.name);
  localStorage.setItem('loginTime', Date.now().toString());
  localStorage.setItem('userRole', userData.user.role || 'student');
};

// Validate API response has correct user
export const validateUserOwnership = (responseUserId, expectedUserId = null) => {
  const currentUserId = getCurrentUser()?.userId;
  const targetUserId = expectedUserId || currentUserId;
  
  if (!targetUserId || responseUserId !== targetUserId) {
    console.error('User ownership validation failed');
    return false;
  }
  
  return true;
};
